export default {

    lista: {
        method: 'get',
        url: 'afastamento/trabalhador/lista'
    },
    pesquisa: {
        method: 'get',
        url: 'boletins/tabela/pesquisa{/id}'
    },
    cadastra: {
        method: 'post',
        url: 'afastamento/trabalhador/cadastro'
    },
    delete: {
        method: 'delete',
        url: 'afastamento/trabalhador/deletar{/id}'
    },
    editar: {
        method: 'get',
        url: 'afastamento/trabalhador/editar{/id}'
    },
    update: {
        method: 'post',
        url: 'afastamento/trabalhador/update'
    },
    show: {
        method: 'get',
        url: 'afastamento/trabalhador/busca'
    },
    // pesquisa:{
    //     method:'get',
    //     url:'cargohoraria/trabalhador/busca{/id}'
    // },
    update2230: {
        method: 'post',
        url: 'afastamento/trabalhador/2230/update'
    },
    cadastra2230: {
        method: 'post',
        url: 'afastamento/trabalhador/2230/cadastro'
    },
    delete2230: {
        method: 'delete',
        url: 'afastamento/trabalhador/2230/deletar{/id}'
    },
    showevento: {
        method: 'post',
        url: 'evento/show'
    },
}
